import {useState} from "react";

import {
    LeasePackageCatalogSummaryDto,
    ReplaceTenantLeasePackageCatalogsDto,
} from "../../model/LeasePackageCatalog";
import {customAxios} from "../customAxios";

export function useReplaceTenantLeasePackageCatalogs() {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<LeasePackageCatalogSummaryDto[]>();
    const [error, setError] = useState<Error>();

    async function execute(tenantId: number, dto: ReplaceTenantLeasePackageCatalogsDto) {
        try {
            setLoading(true);
            setError(undefined);
            const catalogs = await replaceTenantLeasePackageCatalogs(tenantId, dto);
            setData(catalogs);
            return catalogs;
        } catch (e) {
            setError(e as Error);
            return Promise.reject(e);
        } finally {
            setLoading(false);
        }
    }

    return {loading, data, error, execute};
}

export async function replaceTenantLeasePackageCatalogs(
    tenantId: number,
    dto: ReplaceTenantLeasePackageCatalogsDto,
): Promise<LeasePackageCatalogSummaryDto[]> {
    const response = await customAxios.put<LeasePackageCatalogSummaryDto[]>(
        `/v1/tenant/${tenantId}/lease-package-catalogs`,
        dto,
    );
    return response.data;
}
